var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import './conformation-dialog.component.scss';
import { TokenInfoService } from '@synisys/idm-authentication-client-js';
import { AbstractDestructionSubject } from '../../../component/abstract-destruction-subject';
import { takeUntil } from 'rxjs/operators';
var ConformationDialogComponent = /** @class */ (function (_super) {
    __extends(ConformationDialogComponent, _super);
    function ConformationDialogComponent(dialogRef, tokenInfoService) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.tokenInfoService = tokenInfoService;
        return _this;
    }
    ConformationDialogComponent.prototype.onConfirmClick = function () {
        this.dialogRef.close(true);
    };
    ConformationDialogComponent.prototype.onCancelClick = function () {
        this.dialogRef.close(false);
    };
    ConformationDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.tokenInfoService.tokenValidityObservable
            .pipe(takeUntil(this.destroySubject$))
            .subscribe(function (isValid) {
            if (!isValid) {
                _this.dialogRef.close(false);
            }
        }, console.log);
    };
    ConformationDialogComponent = __decorate([
        Component({
            selector: 'confirmation-dialog',
            template: require('./conformation-dialog.component.html'),
        }),
        __metadata("design:paramtypes", [MatDialogRef,
            TokenInfoService])
    ], ConformationDialogComponent);
    return ConformationDialogComponent;
}(AbstractDestructionSubject));
export { ConformationDialogComponent };
//# sourceMappingURL=conformation-dialog.component.js.map